import { Button } from '@dtx-company/design-system/src'
import { FC } from 'react'

export const ManagerCancelButton: FC<{ onClick?: () => void }> = ({ onClick }) => {
  return (
    <Button color="tertiary" variant="text" onClick={onClick} data-testid="manager-cancel-button">
      Cancel
    </Button>
  )
}
